import { CustomChip } from '../../../components/chip/Chip';
import { insertColumnAfter } from '../../../helpers/tools';
import { colorEstadosChip, colorEstadosCIChip } from './colorsEstados';

const columnsRIData = [
    {
        flex: 0.0013,
        field: 'profesionalASignado',
        headerName: 'Profesional Asignado para RI'
    },
    {
        flex: 0.0013,
        field: 'fechaLimite',
        headerName: 'Fecha Limite',
        type: 'date',
        time: true
    },
];

export const columnsAsignacion = [
    {
        flex: 0.0009,
        field: 'idEvaluacion',
        headerName: 'Contrato'
    },
    {
        flex: 0.0009,
        field: 'tipoEvaluacion',
        headerName: 'Origen'
    },
    {
        flex: 0.0010,
        field: 'programa',
        headerName: 'Programa'
    },
    {
        flex: 0.0020,
        field: 'cliente',
        headerName: 'Cliente'
    },
    {
        flex: 0.0008,
        field: 'hC',
        headerName: 'HC'
    },
    {
        flex: 0.0025,
        field: 'paciente',
        headerName: 'Paciente'
    },
    {
        flex: 0.0016,
        field: 'fechaNotificacion',
        headerName: 'Fecha Notificación',
        type: 'date',
        time: true
    }
];

export const columnsAsignacionWithRIData = insertColumnAfter(columnsAsignacion, columnsRIData, 'paciente');
